<template>
  <section>
    <small class="help end">
      <a href="https://www.allianz.fr/assurance-auto/mon-releve-kilometrique" target="_blank">Une question, un problème ? Cliquez ici</a>
    </small>
    <h3>Votre déclaration kilométrique a bien été prise en compte.</h3>
  </section>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: mapState(['datas'])
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  h3 {
    margin: 0;
    padding: spacer();
    font-weight: normal;
    text-align: center;
  }

  .help {
    &.end {
      position: absolute;
      bottom: 0;
      text-align: center;
      font-weight: lighter;
      display: block;
      width: 100%;

      a {
        color: #00a9e0;
        font-size: 1.2em;
        text-decoration: none;
        margin-left: 8px;
      }

      @media (min-width: 760px) {
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 768px;
        font-weight: lighter;

        a {
          color: #00a9e0;
          font-size: 1.2em;
          text-decoration: none;
          margin-left: 8px;
        }
      }
    }
  }
</style>
